import React, {useEffect, useState} from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import FlexContainer from "connectui/component/layout/FlexContainer";
import MessageContentBase from "./MessageContentBase";
import Skeleton from "connectui/component/display/Skeleton";
import MessageBubbleFile from "./file/MessageBubbleFile";
import FilesRow from "./file/FilesRow";
import MessageContentEmail from "./MessageContentEmail";

const MessageContentAttachment = ({isGuestSender, message, ...props}) => {
  const {theme} = useTheme();
  const [isLoading, setIsLoading] = useState(true);
  const [expanded, setExpanded] = useState(true);
  const [attachments, setAttachments] = useState([{isImage: false, link: ""}]);

  useEffect(() => {
    let isMounted = true;
    const checkImage = (attachment) => {
      return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => resolve({link: attachment, isImage: true});
        image.onerror = () => resolve({link: attachment, isImage: false});
        image.src = attachment;
      });
    };

    const loadAttachments = async () => {
      try {
        const files = await Promise.all(
          message.attachments.map((attachment) => checkImage(attachment)),
        );
        if (isMounted) {
          setAttachments(files);
          setIsLoading(false);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error loading attachments:", error);
          setAttachments(
            message.attachments.map((attachment) => ({
              link: attachment,
              isImage: false,
            })),
          );
        }
      }
    };

    loadAttachments();
    return () => {
      isMounted = false;
    };
  }, [message.attachments]);

  const openMobileLink = (url) => () => {
    window.open(url, "_system", "location=yes");
  };

  const renderAttachments = () => {
    if (isLoading) {
      return (
        <Skeleton
          width="100px"
          height="60px"
          style={{
            maxWidth: "85%",
            borderRadius: theme.spacing(
              isGuestSender ? 0 : 2,
              !isGuestSender ? 0 : 2,
              2,
              2,
            ),
          }}
        />
      );
    }

    if (attachments.length === 1) {
      return (
        <MessageBubbleFile
          attachment={attachments[0]}
          isGuestSender={isGuestSender}
          openMobileLink={openMobileLink}
        />
      );
    }

    if (attachments.length > 1) {
      return (
        <FilesRow attachments={attachments} openMobileLink={openMobileLink} />
      );
    }

    return null;
  };

  return (
    <FlexContainer
      flexDirection="column"
      gap={theme.spacing(1.5)}
      sx={{
        overflow: "auto hidden",
        maxWidth: "100%",
        paddingBottom: theme.spacing(1.5),
      }}
    >
      {!!message.message &&
        (props.isEmail ? (
          <MessageContentEmail
            isGuestSender={isGuestSender}
            message={message}
            setIsExpanded={setExpanded}
            {...props}
          />
        ) : (
          <MessageContentBase
            isGuestSender={isGuestSender}
            message={message}
            {...props}
          />
        ))}
      {expanded && renderAttachments()}
    </FlexContainer>
  );
};

export default MessageContentAttachment;
